import React from "react";
// Comps
// Css
import classes from "./Developer.module.scss";

const Developer: React.FC = () => {
  return (
    <div className={classes.container}>
      <div className={classes.oval}>
        <img
          className={classes.image}
          src="assets/img/home/hikack.png"
          alt=""
        />
      </div>
      <p className={`${classes.heading} ${classes.developer}`}>Developed by</p>
      <strong className={`${classes.strong} ${classes.developer}`}>
        Mohammad Sadeghi
      </strong>
      <p className={classes.heading}>Contact:</p>
      <a href="mailto:hikack7@gmail.com" className={classes.link}>
        <strong className={classes.strong}>hikack7@gmail.com</strong>
      </a>
    </div>
  );
};

export default Developer;
